"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var InputLabel = function (_a) {
    var classes = _a.classes, color = _a.color, _b = _a.disableAnimation, disableAnimation = _b === void 0 ? false : _b, disabled = _a.disabled, error = _a.error, focused = _a.focused, margin = _a.margin, required = _a.required, shrink = _a.shrink, variant = _a.variant, children = _a.children, htmlFor = _a.htmlFor;
    return (react_1.default.createElement(InputLabel_1.default, { classes: classes, color: color, disableAnimation: disableAnimation, disabled: disabled, error: error, focused: focused, margin: margin, required: required, shrink: shrink, variant: variant, htmlFor: htmlFor }, children));
};
exports.default = InputLabel;
